"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.Auctions = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _api = require("./api");
var _auction = require("./auction");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
class Auctions {
  /* eslint-disable-next-line */
  // @ts-ignore

  constructor(_ref) {
    let {
      api,
      wallet,
      graphql
    } = _ref;
    this.wallet = void 0;
    this.api = void 0;
    this.status = void 0;
    this.graphql = void 0;
    this.api = api;
    this.wallet = wallet;
    this.graphql = graphql;
    this.status = new _rxjs.BehaviorSubject(false);
    this.init();
  }
  init() {
    this.wallet.isReady$.subscribe(() => this.status.next(true));
  }
  get isReady$() {
    return this.status.pipe((0, _operators.filter)(i => i));
  }
  get isReady() {
    return (0, _rxjs.firstValueFrom)(this.isReady$);
  }
  subscribeList(params) {
    return (0, _rxjs.from)((0, _api.fetchAuctionList)(this.graphql.endpoint, params)).pipe((0, _operators.map)(result => {
      const data = (0, _api.convertApiResult)(result, this.wallet, params);
      return _objectSpread(_objectSpread({}, data), {}, {
        list: data.list.map(item => new _auction.Auction({
          id: item.id,
          api: this.api,
          wallet: this.wallet,
          data: item
        }))
      });
    }));
  }
}
exports.Auctions = Auctions;